import { createContext, useContext } from 'react';

const LetterContext = createContext(null);

export const LetterProvider = LetterContext.Provider;

export const useLetter = () => {
  const ctx = useContext(LetterContext);
  if (!ctx) throw new Error('useLetter must be used inside <LetterShell />');
  return ctx;
};
